import { apiRequest } from "../lib/apiClient";
import type { PermissionOut, RoleDefaultPermissionsOut, UserPermissionsOut, UserPermissionsPatchRequest } from "./types";

/** `GET /permissions` — the full catalog, open to any authenticated user. */
export async function listPermissions(accessToken: string): Promise<PermissionOut[]> {
  return apiRequest<PermissionOut[]>("/permissions", { accessToken });
}

/** `GET /roles/{role}/permissions` — OWNER-only. Read-only view of a role's default set. */
export async function getRoleDefaultPermissions(accessToken: string, role: string): Promise<RoleDefaultPermissionsOut> {
  return apiRequest<RoleDefaultPermissionsOut>(`/roles/${role}/permissions`, { accessToken });
}

/** `GET /users/{id}/permissions` — OWNER-only. */
export async function getUserPermissions(accessToken: string, userId: string): Promise<UserPermissionsOut> {
  return apiRequest<UserPermissionsOut>(`/users/${userId}/permissions`, { accessToken });
}

/** `PATCH /users/{id}/permissions` — OWNER-only. Grant/revoke/reset individual overrides. */
export async function updateUserPermissions(
  accessToken: string,
  userId: string,
  body: UserPermissionsPatchRequest,
): Promise<UserPermissionsOut> {
  return apiRequest<UserPermissionsOut>(`/users/${userId}/permissions`, { method: "PATCH", accessToken, body });
}
